import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react';

interface IProps {
  isLoading: boolean;
}

export function Loading({ isLoading }: IProps) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
